// RemarkModal.tsx
import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";

interface RemarkModalProps {
  isOpen: boolean;
  toggle: () => void;
  leadId: number | null;
  currentRemark: string;
  onSave: (leadId: number, remark: string) => void;
}

const RemarkModal: React.FC<RemarkModalProps> = ({ isOpen, toggle, leadId, currentRemark, onSave }) => {
  const [remark, setRemark] = useState(currentRemark);

  useEffect(() => {
    setRemark(currentRemark);
  }, [currentRemark]);

  const handleSave = () => {
    if (!remark.trim()) return; // ✅ Prevent saving empty remark
    if (leadId) onSave(leadId, remark);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add / Edit Remark</ModalHeader>
      <ModalBody>
        <Input
          type="textarea"
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter your note here..."
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancel</Button>

        {/* ✅ Save disabled when remark is empty */}
        <Button 
          color="primary" 
          onClick={handleSave}
          disabled={!remark.trim()}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RemarkModal;
